import { blackLight, whiteLight } from 'styleVars/getColors';

export const hintStyles = {
  tooltip: {
    opacity: '0.9',
    margin: '10px',
    padding: '4px 10px',
    borderRadius: '13px',
    backgroundColor: blackLight,
    fontFamily: 'OpenSans, sans-serif',
    fontSize: '14px',
    fontWeight: '300',
    textAlign: 'center',
    color: whiteLight,
  },
  popper: {
    padding: '10px',
  },
};
